import transCore from './transCore';
import wrapTWithDefaultNs from './wrapTWithDefaultNs';
export default function createTranslation(defaultNS) {
    var _a;
    var _b = (_a = globalThis.__NEXT_TRANSLATE__) !== null && _a !== void 0 ? _a : {}, lang = _b.lang, namespaces = _b.namespaces, config = _b.config;
    var localesToIgnore = config.localesToIgnore || ['default'];
    var ignoreLang = !lang || localesToIgnore.includes(lang);
    var t = transCore({
        config: config,
        allNamespaces: namespaces,
        pluralRules: new Intl.PluralRules(ignoreLang ? undefined : lang),
        lang: lang,
    });
    return { t: wrapTWithDefaultNs(t, defaultNS), lang: lang };
}
